import { makeAutoObservable, runInAction } from 'mobx';
import {jwtDecode} from 'jwt-decode'; // ✅ default import
import AuthApiService from '../services/api/AuthApiService';

export const AUTH_TOKENS_KEY = 'authToken';

class AuthStore {
  public username = '';
  public password = '';
  public isLoading = false;
  public currentUser: any = null;
  public error: string | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public setUsername(username: string) {
    this.username = username;
  }

  public setPassword(password: string) {
    this.password = password;
  }

  public checkIsAuthorized() {
    const token = localStorage.getItem(AUTH_TOKENS_KEY);
    try {
      this.currentUser = token ? jwtDecode<any>(token) : null;
    } catch (e) {
      console.warn('Не удалось декодировать токен:', e);
      this.currentUser = null;
    }
    return this.currentUser !== null;
  }

  public async signIn() {
    try {
      this.isLoading = true;
      const data = await AuthApiService.login({
        username: this.username,
        password: this.password,
      });

      if (!data?.token) throw new Error('Token not returned from server');

      localStorage.setItem(AUTH_TOKENS_KEY, data.token);
      runInAction(() => {
        this.currentUser = jwtDecode<any>(data.token); // ✅
        this.error = null;
      });
    } catch (e: any) {
      runInAction(() => {
        this.error = e?.response?.data?.error || 'Login failed';
      });
      console.error(e);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public async register(userData: {
    username: string;
    password: string;
    email?: string;
    birthDate?: string;
    gender?: string;
    height?: number;
    weight?: number;
    dominantHand?: string;
    activityLevel?: string;
    healthLimitations?: string[];
  }) {
    try {
      this.isLoading = true;

      const payload = {
        username: userData.username,
        password: userData.password,
        email: userData.email,
        birth_date: userData.birthDate,
        gender: userData.gender,
        height: userData.height,
        weight: userData.weight,
        handedness: userData.dominantHand,
        activity_level: userData.activityLevel,
        limitations: userData.healthLimitations,
        role: 'user',
      };

      console.log('Отправляем на основной сервер payload:', payload);
      await AuthApiService.register(payload);

      if (userData.email) {
        try {
          const secondaryRes = await AuthApiService.registerSecondary({
            username: userData.username,
            password: userData.password,
            email: userData.email,
          });

          if (!secondaryRes.ok) {
            const errData = await secondaryRes.json();
            if (secondaryRes.status === 409) {
              console.warn('Имя пользователя уже занято в Atavism:', errData);
            } else {
              console.warn('Ошибка регистрации в Atavism:', errData);
            }
          }
        } catch (err) {
          console.warn('Вторая регистрация Atavism не прошла:', err);
        }
      }

      runInAction(() => {
        this.error = null;
      });
    } catch (e: any) {
      runInAction(() => {
        this.error = e?.response?.data?.error || e?.message || 'Registration failed';
      });
      console.error(e);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  public clearUserInfo() {
    localStorage.removeItem(AUTH_TOKENS_KEY);
    this.currentUser = null;
    this.error = null;
  }
}

export default new AuthStore();
